import React from "react";

export default function OneItem({ title, item, className }) {
  return (
    <p className={`${className} text-[10px]`}>
      <span className="font-bold">{title}:</span>
      <span className="ml-2">{item}</span>
    </p>
  );
}
